import React from "react";
import { useTheme } from '@material-ui/core/styles';


const ChironLoadingOverlay = (props) => {
  const isDark = useTheme().palette.type === 'dark';

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: isDark ? 'rgba(48,48,48,0.6)' : 'rgba(255,255,255,0.7)',
    zIndex: 2
  }
  return (
    <div style={overlayStyle}>
      <i className="fa fa-circle-notch fa-spin fa-2x"></i>
    </div>
  );
}

export default ChironLoadingOverlay;